import {createUseStyles} from 'react-jss'

export default createUseStyles({
  planBullets: {
    width: '100%'
  },
  planBullet: {
    margin: [10, 0]
  }
})